import React, { useState, useEffect } from 'react';
import { gql, useMutation, useQuery } from '@apollo/client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse}from '@fortawesome/free-solid-svg-icons';

const GET_PRODUCTOS = gql`
  query getProductos {
    getProductos {
      _id
      nombre
      imagen
      codigo
      precio
      stock
    }
  }
`;

const ACTUALIZAR_STOCK = gql`
  mutation actualizarStock($id: ID!, $nuevoStock: Int) {
    actualizarStock(_id: $id, stock: $nuevoStock) {
      _id
      nombre
      precio
      stock
      codigo
      imagen
    }
  }
`;

function MostrarCarrito() {
  const [carrito, setCarrito] = useState([]);
  const [total, setTotal] = useState(0);
  const { loading, error, data } = useQuery(GET_PRODUCTOS);
  const [actualizarStockProducto] = useMutation(ACTUALIZAR_STOCK);

  useEffect(() => {
    const carritoGuardado = JSON.parse(localStorage.getItem('carrito')) || [];
    setCarrito(carritoGuardado);
  }, []);

  useEffect(() => {
    localStorage.setItem('carrito', JSON.stringify(carrito));
    recalcularTotal();
  }, [carrito]);

  const modificarCantidad = async (productId, nuevaCantidad) => {
    const productoEnCarrito = carrito.find(
      (producto) => producto._id === productId
    );
    const productoEnData = data.getProductos.find(
      (producto) => producto._id === productId
    );

    if (!productoEnCarrito || !productoEnData) return;

    if (productoEnData.codigo !== "1" && productoEnData.codigo !== "2") {
      const diferencia = nuevaCantidad - productoEnCarrito.cantidad;

      if (nuevaCantidad <= 0) {
        return eliminarProductoDelCarrito(productId);
      }

      if (productoEnData.stock < diferencia) {
        alert('No hay suficiente stock disponible para este producto.');
        return;
      }

      const nuevoStock = productoEnData.stock - diferencia;
      await actualizarStockProducto({
        variables: { id: productId, nuevoStock },
      });
    }

    const carritoActualizado = carrito.map((item) =>
      item._id === productId ? { ...item, cantidad: nuevaCantidad } : item
    );
    setCarrito(carritoActualizado);
  };

  const eliminarProductoDelCarrito = async (productId) => {
    const productoEnCarrito = carrito.find(
      (producto) => producto._id === productId
    );

    if (productoEnCarrito) {
      const productoEnData = data.getProductos.find(
        (producto) => producto._id === productId
      );

      if (productoEnData.codigo !== "1" && productoEnData.codigo !== "2") {
        const nuevoStock = productoEnData.stock + productoEnCarrito.cantidad;
        await actualizarStockProducto({
          variables: { id: productId, nuevoStock },
        });
      }
    }

    const carritoActualizado = carrito.filter(
      (producto) => producto._id !== productId
    );
    setCarrito(carritoActualizado);
  };

  const recalcularTotal = () => {
    if (carrito.length === 0 || carrito.every(producto => producto.cantidad === 0)) {
      setTotal(0);
      return;
    }

    const nuevoTotal = carrito.reduce((acc, producto) => {
      const subtotal =
        producto.codigo === "1"
          ? producto.precio * producto.cantidad + 200
          : producto.precio * producto.cantidad;
      return acc + subtotal;
    }, 0);
    setTotal(nuevoTotal);
  };

  if (loading) return <p>Esperando resultados...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div>
       <a className='btn-medicina btn' href="/ver-productos">
        <FontAwesomeIcon icon={faHouse} />
      </a>
      <ul>
        {carrito.slice().reverse().map((producto, index) => (
          <li key={index}>
            <h5>
              <img src={producto.imagen} width="40px" alt="" />
              {producto.nombre}.....precio: ${producto.precio}
              .....subtotal: $
              {producto.codigo === "1"
                ? producto.precio*1000 * producto.cantidad + 200
                : producto.precio * producto.cantidad}
              <input
                type="number"
                value={producto.cantidad}
                min="0"
                onChange={(e) => {
                  const value = e.target.value === '' ? 0 : parseInt(e.target.value, 10);
                  modificarCantidad(producto._id, isNaN(value) ? 0 : value);
                }}
                style={{ width: '50px', margin: '0 10px' }}
              />
              <button
                className="btn btn-danger"
                onClick={() => eliminarProductoDelCarrito(producto._id)}
              >
                Eliminar
              </button>
            </h5>
          </li>
        ))}
      </ul>
      {carrito.length > 0 && (
        <div>
          <h2>Total a pagar: ${total.toFixed()}</h2>
        </div>
      )}
    </div>
  );
}

export default MostrarCarrito;
